// Rueckmeldung zur Pflanzenerkennung: was wurde nach einer Erkennung
// WIRKLICH boniert? Das ist das Label der Trainingsdaten in der Zentrale
// (Nutzer-Entscheid 29.9.2026: "Modell + tatsaechlich boniert").
//
// merken(id, aufraeumen) - nach einer erfolgreichen Erkennung mit Zentrale
// boniert(prodId, bonId) - aus CBonManager.preAddEntryPOS, bei JEDEM Produkt
//
// Gemeldet wird nur das ERSTE Produkt nach der Erkennung und nur innerhalb
// von drei Minuten - danach hat der Kassierer laengst etwas anderes getan.
// "Feuern und vergessen": ein Fehler hier darf nie einen Bon beruehren.
var FRIST_MS = 3 * 60 * 1000;
var offen = null;   // { id, zeit, aufraeumen }

export function merken(id, aufraeumen) {
    vergessen();
    if (id) offen = { id: String(id), zeit: Date.now(), aufraeumen: aufraeumen || null };
}

export function vergessen() {
    var alt = offen;
    offen = null;
    if (alt && alt.aufraeumen) {
        try { alt.aufraeumen(); } catch (e) { /* nur Markierung */ }
    }
}

export function boniert(prodId, bonId) {
    if (!offen) return;
    var eintrag = offen;
    vergessen();
    if (Date.now() - eintrag.zeit > FRIST_MS || !(Number(prodId) > 0)) return;
    try {
        $.ajax({
            url: 'pflanze/boniert',
            type: 'POST',
            contentType: 'application/json',
            data: JSON.stringify({ id: eintrag.id, prodId: Number(prodId), bonId: bonId || null }),
            timeout: 10000,
        });
    } catch (e) { /* nie den Bon stoeren */ }
}
